import { useEffect, useState } from 'react';
import { type RaceVideoAnswer, waitForRaceVideo } from '../../../lib/raceVideo';

export type RaceVideoState = { status: 'loading' } | RaceVideoAnswer;

/** Polls gears-api until the starter's race video is rendered, or known not to exist. */
export function useRaceVideo(eventId: string, starterId: string): RaceVideoState {
  const [state, setState] = useState<RaceVideoState>({ status: 'loading' });

  useEffect(() => {
    const controller = new AbortController();
    waitForRaceVideo(eventId, starterId, controller.signal, () => setState({ status: 'rendering' }))
      .then(setState)
      .catch(() => {
        if (!controller.signal.aborted) setState({ status: 'error' });
      });
    return () => controller.abort();
  }, [eventId, starterId]);

  return state;
}
